<div #screen>
  <div class="feedbackButtonArea" *ngIf="showFeedbackButton">
    <button class="btn btn-link icon-before icon-feedback-button" (click)='provideFeedback()'>Feedback</button>
  </div>

  <router-outlet></router-outlet>
</div>